import { validators_context_value } from '../types';

export const createDefaultValidatorsContextValue = (): validators_context_value => ({});

export default createDefaultValidatorsContextValue;
